<small class="debug">{{me}}</small>
<mat-card appearance="outlined" *ngIf="!dialogGetAsset; else dialogView">
    <div style="display: flex; width: 100%">
        <button mat-button class="icon-button" routerLink="/editor/list" href="#">
            <mat-icon>arrow_back</mat-icon>
        </button>

        <app-video-link videoLink="importScene"></app-video-link>


        <button class="goBack" mat-button style="position: absolute; right: 0px" routerLink="/editor/list" href="#">
            <mat-icon>close</mat-icon>
        </button>
    </div>
    <div fxFill>
        <mat-drawer-container>
            <mat-drawer opened [mode]="sidenavMode" #sidenav  [disableClose]="sidenavMode === 'side'">
                <div fxLayout="row" fxLayoutAlign="center" class="side-main-menu">
                    <mat-icon (click)="sidenav.close()" style="position: absolute; right: 10px; top: 5px; cursor: pointer">keyboard_double_arrow_left</mat-icon>
                </div>
                <div class="list-container main-container" fxFlex="285px">
                    <ng-template [ngTemplateOutlet]="sceneCategory">
                    </ng-template>
                </div>
            </mat-drawer>
            <mat-drawer-content>
                <div class="list-container" fxFlex="100%">
                    @if (!sidenav.opened) {
                        <mat-icon (click)="sidenav.open()" style="position: absolute; left: 10px; top: 5px; cursor: pointer; z-index: 9999">keyboard_double_arrow_right</mat-icon>
                    }


                    @if (importType === 'shared') {
                        <app-scene-shared-contents [setSharedContents]="sharedContents" [selection]="sharedBusinessIds"></app-scene-shared-contents>
                    } @else {
                        @if (m_data) {
                            <app-scene-importer
                                [dialogGetAsset]="m_data"
                                [autoOpenOnImport]="true"
                                (itemSelected)="onItemSelected($event)">
                            </app-scene-importer>
                        } @else {
                            <div class="imageWrap" style="width: 100%; height: 100%" fxLayout="row" fxLayoutAlign="center center">
                                <h1 class="big-message hide-lt-lg">{{'general.sceneCollection' | transloco}}</h1>
                                <h2 class="hide-gt-md" style="font-size: 1.4em">{{'general.sceneCollection' | transloco}}</h2>
                            </div>
                        }
                    }
                </div>

            </mat-drawer-content>
        </mat-drawer-container>
    </div>
</mat-card>
<ng-template #dialogView>
    <div fxLayout="row" class="library-dialog-view flex-lt-md-col">
        <div class="list-container main-container flex-lt-md-100" fxFlex="285px">
            <ng-template [ngTemplateOutlet]="sceneCategory">
            </ng-template>
        </div>
        <div class="list-container" fxFlex="100%">
            @if (importType === 'shared') {
                <app-scene-shared-contents [setSharedContents]="sharedContents" [selection]="sharedBusinessIds"></app-scene-shared-contents>
            } @else {
                @if (m_data) {
                    <app-scene-importer
                        [dialogGetAsset]="m_data"
                        [autoOpenOnImport]="false"
                        (itemSelected)="onItemSelected($event)">
                    </app-scene-importer>
                } @else {
                    <div class="imageWrap" style="width: 100%; height: 100%" fxLayout="row" fxLayoutAlign="center center">
                        <h1 class="hide-lt-lg">{{'general.sceneCollection' | transloco}}</h1>
                        <h2 class="hide-gt-md" style="font-size: 1.4em">{{'general.sceneCollection' | transloco}}</h2>
                    </div>
                }
            }
        </div>
    </div>
</ng-template>

<ng-template #sceneCategory>
    <mat-accordion class="w-100">
        <mat-expansion-panel [expanded]="true" (opened)="openGroup('categories')">
            <mat-expansion-panel-header>
                <mat-panel-title>
                    <mat-icon>account_tree</mat-icon>
                    <span class="accordionIcons">{{'general.categorizedScenes' | transloco}}</span>
                </mat-panel-title>
                <mat-panel-description>
                </mat-panel-description>
            </mat-expansion-panel-header>
            <app-category-tree #treeCategory style="width: 100%; height: 100%;" [createMode]="false" [filterMode]="true" [expandAll]="true" [setCategoryValues]="categoryTreeItems" (updateTreeSelection)="onUpdateTree($event)"></app-category-tree>
        </mat-expansion-panel>
        <mat-expansion-panel (opened)="openGroup('specialized')">
            <mat-expansion-panel-header>
                <mat-panel-title>
                    <mat-icon>view_list</mat-icon>
                    <span class="accordionIcons">{{'general.specializedScenes2' | transloco}}</span>
                </mat-panel-title>
                <mat-panel-description>
                </mat-panel-description>
            </mat-expansion-panel-header>
            <mat-form-field>
                <mat-label>{{'placeholder.filterList' | transloco}}</mat-label>
                <input inputrestriction="basic1" matInput type="text" (keyup)="applyFilter($event.target['value'])" class="form-control" [value]="filter"
                       autocomplete="off"/>
                <a matSuffix aria-label="Clear" (click)="applyFilter('')">
                    <mat-icon>close</mat-icon>
                </a>
            </mat-form-field>
            <mat-radio-group aria-labelledby="example-radio-group-label" class="example-radio-group">
                <mat-radio-button *ngFor="let jsonType of filteredJsonTypes" [value]="jsonType" (change)="selectType($event)" class="example-radio-button">
                    <fa-icon class="faCogs" [icon]="jsonType.icon"></fa-icon>
                    {{'mimes.' + jsonType.label | transloco }}
                </mat-radio-button>
            </mat-radio-group>
        </mat-expansion-panel>
        <mat-expansion-panel *ngIf="enterprise" (opened)="openGroup('shared')">
            <mat-expansion-panel-header>
                <mat-panel-title>
                    <mat-icon>share</mat-icon>
                    <span class="accordionIcons">{{'general.accountShared' | transloco}}</span>
                </mat-panel-title>
                <mat-panel-description>
                </mat-panel-description>
            </mat-expansion-panel-header>
            <!-- todo add tree for scenes or resources -->
            <button style="width: 100%" (click)="syncSharedContents()" mat-stroked-button color="warn">
                <mat-icon>cached</mat-icon>
                {{'general.syncContent' | transloco}}
            </button>
            @if (isUpdatingEnterprise) {
                <div style="margin-bottom: 30px;">
                    <app-loading [size]="'50px'" [style]="{ 'margin-top': '30px' }"></app-loading>
                </div>
            } @else {
                <div style="margin-top: 30px;">
                    <app-category-tree #treeCategory style="width: 100%; height: 100%;" [createMode]="false" [filterMode]="false" [expandAll]="false" [setCategoryValues]="sharedContentTreeItems" (updateTreeSelection)="onUpdateShareContentTree($event)"></app-category-tree>
                </div>
            }
        </mat-expansion-panel>
    </mat-accordion>
</ng-template>
